import * as Objdict from "objdict"
import shortid from "shortid"

import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"
import Zone from "@frog/source/models/Zone.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Elements from "@frog/source/data/elements.js"
import Tiled from "@frog/source/utility/Tiled.js"
import Motions from "@frog/source/juice/utility/Motions.js"

import Ink from "@frog/source/utility/Ink.js"
import InkDialogue from "@frog/source/utility/InkDialogue.js"

import ranges from "@frog/source/data/skills/parts/ranges.js"

function getFacing(direction) {
    const WEST = {"x": -1, "y": 0}
    const NORTH = {"y": -1, "x": 0}
    if(Geometry.equals(direction, WEST)
    || Geometry.equals(direction, NORTH)) {
        return "back"
    } else {
        return "front"
    }
}

const skills = {}
export default skills

// Will do zero damage if it is not overriden with a power attribute
// or if the performer does not have any power attribute.
skills["inflict-damage"] = {
    "type": "invoke",
    "class": "attack",
    "canCounterattack": true,

    "power": 0,
    "range": ranges["short"],

    "isIgnoringArmor": false,
    "isIgnoringElements": false,

    "name": "Squash",

    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target != undefined) {
            return target.affiliation != performer.affiliation
                && (performer.affiliation == "bad" || target.affiliation != "none")
        }
        return true
    },

    // "demonstration": {
    //     "stage": {
    //         "world": Tiled.parse({
    //             "tilemap": require("@frog/source/data/encounters/empty.tilemap.json"),
    //             "tileset": require("@frog/source/assets/images/hero-tactics/map/heroes.tileset.json"),
    //         }),
    //         "units": [
    //             {
    //                 "key": "apple2",
    //                 "affiliation": "good",
    //                 "class": "captain",
    //                 "position": {"x": 0, "y": 1},
    //                 "level": 2,
    //                 "equippedSkills": {
    //                     "support1": "inflict-damage element:ground flavor:smash",
    //                 }
    //             },
    //             {
    //                 "key": "banana2",
    //                 "affiliation": "bad",
    //                 "class": "captain",
    //                 "position": {"x": 2, "y": 1},
    //                 "level": 1
    //             }
    //         ]
    //     },
    //     "actions": [
    //         {
    //             "type": "invoke skill",
    //             "unitKey": "apple2",
    //             "skillKey": "inflict-damage element:ground flavor:smash",
    //             "previousPosition": {"x": 1, "y": 1},
    //             "nextPosition": {"x": 2, "y": 1},
    //         }
    //     ]
    // },

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const distance = Geometry.distance(position, performer.position)

        Step.add(step, {"mark": 0, "flourish": {"name": "SwingBackMovement", "unit": {"key": performer.key}, "direction": direction, "position": performer.position}})
        Step.add(step, {"mark": 280, "audio": {"triggerKey": distance > 1 && performer.affiliation == "good" ? "Unit:Attack:Ranged" : "Unit:Attack:Melee"}})

        const target = Stage.findUnitByPosition(step.omegastage, position)

        if(target == undefined) {
            return step
        }

        ////////////////
        // AGGRO-ING //
        //////////////

        // if(performer.affiliation == "bad") {
        //     Object.values(step.omegastage.units).forEach((unit) => {
        //         if(unit.affiliation == "bad"
        //         && unit.state != "aggroed"
        //         && Zone.isInBounds(step.omegastage.encounters[step.omegastage.currentEncounter || 1].zone, unit.position)) {
        //             Step.add(step, {
        //                 "mark": 0,
        //                 "unit": {
        //                     "key": unit.key,
        //                     "state": "aggroed"
        //                 },
        //             })
        //             Step.add(step, {
        //                 "mark": 0,
        //                 "flourish": {
        //                     "name": "TextFloat",
        //                     "position": unit.position,
        //                     "font": "labels",
        //                     "text": "!"
        //                 }
        //             })
        //         }
        //     })
        // }

        /////////////
        // DAMAGE //
        ///////////

        let hitmark = 300 + ((this.range.max - 1) * 50)

        // do a pre-damage if it is a shield-piercer!!
        const armortype = this.armortype || "steel"
        if(target.armor > 0
        && target.armortype != armortype) {
            const damage = target.armor
            Step.add(step, {"mark": hitmark, "flourish": {"name": "NudgedMovement", "unit": {"key": target.key}, "direction": direction, "position": target.position}})
            Step.add(step, {
                "mark": hitmark,
                "flourish": {
                    "name": "TextFloat",
                    "position": target.position,
                    "text": (damage > 0 ? "-" : "") + damage,
                    "type": "damage",
                    "unitKey": target.key
                }
            })

            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": target.key,
                    "armor": 0,
                },
            })

            hitmark += 100
        }

        // make this a double attack for elemental!!

        const innatePower = 1
        // performer.power ?? 1 // this.power + (performer.power || 0)

        // // ELEMENTAL SUPER-EFFECTIVE AS DAMAGE BUFF
        // let elementalPower = 0
        // if(this.isIgnoringElements != true) {
        //     const attackElement = this.element || performer.element
        //
        //     if(attackElement != undefined) {
        //         // if(target.element == undefined) {
        //         //     console.log(target, target.element, Elements[target.element])
        //         // }
        //         if(Elements[target.element]?.weaknesses != undefined
        //         && Elements[target.element].weaknesses.includes(attackElement)) {
        //             // elementalPower += Math.ceil(innatePower * 0.5)
        //             elementalPower += 1
        //         }
        //         if(Elements[target.element]?.strengths != undefined
        //         && Elements[target.element].strengths.includes(attackElement)) {
        //             // elementalPower -= Math.floor(innatePower * 0.5)
        //             // elementalPower -= 1
        //         }
        //     }
        // }

        performDamage(innatePower)

        const attackElement = this.element || performer.element
        if(attackElement != undefined) {
            if(Elements[target.element]?.weaknesses != undefined
            && Elements[target.element].weaknesses.includes(attackElement)) {
                performDamage(innatePower)
            }
        }

        function performDamage(totalDamage) {
            let damage = totalDamage

            if(target.armor > 0) {
                const armor = target.armor
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": target.key,
                        "armor": Math.max(0, armor - damage),
                    },
                })

                damage -= armor
                damage = Math.max(0, damage)
            }

            if(damage > 0) {
                Step.add(step, {
                    "mark": hitmark,
                    "unit": {
                        "key": target.key,
                        "health": Math.min(target.maxhealth, Math.max(0, target.health - damage)),
                    },
                })
            }

            Step.add(step, {"mark": 0, "unit": {"key": performer.key, "mode": "nothing"}})
            Step.add(step, {"mark": hitmark-150, "unit": {"key": performer.key, "mode": "attack"}})
            Step.add(step, {"mark": hitmark, "unit": {"key": performer.key, "mode": "nothing"}})

            Step.add(step, {"mark": hitmark, "flourish": {"name": "NudgedMovement", "unit": {"key": target.key}, "direction": direction, "position": target.position}})
            Step.add(step, {"mark": hitmark, "flourish": {"name": "TextFloat", "position": target.position, "text": (totalDamage > 0 ? "-" : "") + totalDamage, "type": "damage", "unitKey": target.key}})
            Step.add(step, {"mark": hitmark, "func": function() {
                console.log("!!")
                if(window.tutorial == 1
                || window.tutorial == 2) {
                    window.tutorial += 1
                }
            }})

            // if(totalDamage == 0) {
            //     Step.add(step, {"mark": hitmark, "audio": {"triggerKey": "Unit:Attack:NoDamage"}})
            // } else if(target.health < 0) {
            //     Step.add(step, {"mark": hitmark, "audio": {"triggerKey": "Unit:Attack:FinalHit"}})
            // } else {
            //     Step.add(step, {"mark": hitmark, "audio": {"triggerKey": "Unit:Attack:Hit"}})
            // }

            hitmark += 300
        }

        // if(performer.effects.burning != undefined) {
        // Step.add(step, {
        //     "mark": hitmark,
        //     "unit": {
        //         "key": target.key,
        //         "effects": {
        //             "burning": {
        //                 "timer": 10,
        //                 "type": "at-end-of-turn",
        //                 // "skillKey": "burn",
        //                 "skillKey": "inflict-damage",
        //             }
        //         }
        //     },
        // })

        // if(target.affiliation == "bad") {
        //     Object.values(step.omegastage.units).forEach((unit) => {
        //         if(unit.affiliation == "bad"
        //         && unit.state != "aggroed"
        //         && Zone.isInBounds(step.omegastage.encounters[step.omegastage.currentEncounter || 1].zone, unit.position)) {
        //             Step.add(step, {
        //                 "mark": hitmark,
        //                 "unit": {
        //                     "key": unit.key,
        //                     "state": "aggroed"
        //                 },
        //             })
        //             Step.add(step, {
        //                 "mark": hitmark,
        //                 "flourish": {
        //                     "name": "TextFloat",
        //                     "position": unit.position,
        //                     "font": "labels",
        //                     "text": "!"
        //                 }
        //             })
        //         }
        //     })
        // }

        if(target.properties != undefined
        && target.properties.isThorny == true
        && this.range.min == 1 && this.range.max == 1) {
            Step.add(step, {
                "mark": hitmark,
                "unit": {
                    "key": performer.key,
                    "health": performer.health - 1,
                },
            })
        }

        step.followupSteps = []
        function queueupEvent(event) {
            step.followupSteps.push(Stage.processEventSteps(step.omegastage, event))
        }

        queueupEvent({"func": (stage) => Ink.increment(performer.type + "_attack_count")})
        queueupEvent({"func": (stage) => Ink.increment(performer.classname + "_attack_count")})

        queueupEvent(InkDialogue(target.type + "_was_attacked"))
        queueupEvent(InkDialogue(target.classname + "_was_attacked"))

        queueupEvent(InkDialogue(performer.type + "_has_attacked_" + target.type))
        queueupEvent(InkDialogue(performer.type + "_has_attacked_" + target.classname))
        queueupEvent(InkDialogue(performer.classname + "_has_attacked_" + target.type))
        queueupEvent(InkDialogue(performer.classname + "_has_attacked_" + target.classname))

        if(target.health <= 0) {
            // This is commented out because we're already emiting those checks in Reactions.getDeaths
            // queueupEvent(InkDialogue(target.type + "_was_squashed"))
            // queueupEvent(InkDialogue(target.classname + "_was_squashed"))

            if(target.type == "bug") {
                queueupEvent({"func": (stage) => Ink.increment(performer.type + "_squash_count")})
                queueupEvent({"func": (stage) => Ink.increment(performer.classname + "_squash_count")})

                queueupEvent(InkDialogue(performer.type + "_has_squashed_" + target.type))
                queueupEvent(InkDialogue(performer.type + "_has_squashed_" + target.classname))
                queueupEvent(InkDialogue(performer.classname + "_has_squashed_" + target.type))
                queueupEvent(InkDialogue(performer.classname + "_shas_quashed_" + target.classname))
            }
            if(target.type == "gaurdner") {
                queueupEvent({"func": (stage) => Ink.increment(target.type + "_drop_count", target.score || 0)})
                queueupEvent({"func": (stage) => Ink.increment(target.classname + "_dropt_count", target.score || 0)})

                queueupEvent(InkDialogue(performer.type + "_has_routed_" + target.type))
                queueupEvent(InkDialogue(performer.type + "_has_routed_" + target.classname))
                queueupEvent(InkDialogue(performer.classname + "_has_routed_" + target.type))
                queueupEvent(InkDialogue(performer.classname + "_has_routed_" + target.classname))
            }
            if(target.type == "plant") {
                queueupEvent(InkDialogue(performer.type + "_has_eaten_" + target.type))
                queueupEvent(InkDialogue(performer.type + "_has_eaten_" + target.classname))
                queueupEvent(InkDialogue(performer.classname + "_has_eaten_" + target.type))
                queueupEvent(InkDialogue(performer.classname + "_has_eaten_" + target.classname))
            }
        }


        return step
    }
}

skills["restore-health"] = {
    "type": "invoke",
    "class": "support",
    "canCounterattack": false,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        // if(target != undefined
        // && target.affiliation != performer.affiliation) {
        //     return false
        // }
        return true
    },

    "power": 0,
    "range": ranges["short"],

    // "demonstration": {
    //     "stage": {
    //         "world": Tiled.parse({
    //             "tilemap": require("@frog/source/data/encounters/empty.tilemap.json"),
    //             "tileset": require("@frog/source/assets/images/hero-tactics/map/heroes.tileset.json"),
    //         }),
    //         "units": [
    //             {
    //                 "key": "apple2",
    //                 "affiliation": "good",
    //                 "class": "captain",
    //                 "position": {"x": 0, "y": 1},
    //                 "level": 2,
    //                 "equippedSkills": {
    //                     "support1": "inflict-damage element:ground flavor:smash",
    //                 }
    //             },
    //             {
    //                 "key": "banana2",
    //                 "affiliation": "bad",
    //                 "class": "captain",
    //                 "position": {"x": 2, "y": 1},
    //                 "level": 1
    //             }
    //         ]
    //     },
    //     "actions": [
    //         {
    //             "type": "invoke skill",
    //             "unitKey": "apple2",
    //             "skillKey": "inflict-damage element:ground flavor:smash",
    //             "previousPosition": {"x": 1, "y": 1},
    //             "nextPosition": {"x": 2, "y": 1},
    //         }
    //     ]
    // },

    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]

        const direction = Geometry.direction(position, performer.position)

        const deltastages = []
        const HIT_MARK = 0

        Step.add(step, {"mark": HIT_MARK, "flourish": {"name": "NudgedMovement", "unit": {"key": performer.key}, "direction": direction, "position": performer.position}})
        Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Heal"}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step

        let healing = this.power + (performer.power || 0)
        if(target.health + healing > target.maxhealth) {
            healing = target.maxhealth - target.health
        }

        Step.add(step, {
            "mark": HIT_MARK,
            "unit": {
                "key": target.key,
                "health": target.health + healing
            },
        })

        if(target.effects.burning != undefined) {
            Step.add(step, {
                "mark": HIT_MARK,
                "unit": {
                    "key": target.key,
                    "effects": {
                        "burning": undefined,
                    }
                },
            })
        }

        Step.add(step, {"mark": HIT_MARK, "flourish": {"name": "NudgedMovement", "unit": {"key": target.key}, "direction": Geometry.flip(direction), "position": target.position}})
        Step.add(step, {"mark": HIT_MARK, "flourish": {"name": "TextFloat", "position": target.position, "text": healing}})

        return step
    }
}

skills["look"] = {
    "type": "invoke",
    "class": "attack",
    "canCounterattack": false,

    "power": 0,
    "range": {
        "min": 1,
        "max": 2,
        "orthogonal": true,
        "diagonal": true,
        "arc": true,
        // "type": "arc"
    },

    "name": "Look",

    "calculateStep": function({stage, position, performerKey, effectKey}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]

        const target = Stage.findUnitByPosition(step.omegastage, position)

        if(target == undefined) {
            return step
        }

        ////////////////
        // AGGRO-ING //
        //////////////

        // if(performer.affiliation == "bad") {
        //     Object.values(step.omegastage.units).forEach((unit) => {
        //         if(unit.affiliation == "bad"
        //         && unit.state != "aggroed"
        //         && Zone.isInBounds(step.omegastage.encounters[step.omegastage.currentEncounter || 1].zone, unit.position)) {
        //             Step.add(step, {
        //                 "mark": 0,
        //                 "unit": {
        //                     "key": unit.key,
        //                     "state": "aggroed"
        //                 },
        //             })
        //             Step.add(step, {
        //                 "mark": 0,
        //                 "flourish": {
        //                     "name": "TextFloat",
        //                     "position": unit.position,
        //                     "font": "labels",
        //                     "text": "!"
        //                 }
        //             })
        //         }
        //     })
        // }

        return step
    }
}
